import React, { useContext } from 'react';
import { AppSidebar, AppSidebarMenuItem } from '@redpanda/ui';
import {
  PresentationChartBarIcon,
  CalendarDaysIcon,
  UserGroupIcon,
  WrenchScrewdriverIcon,
  UsersIcon,
  BuildingStorefrontIcon,
  LinkIcon,
} from '@heroicons/react/24/outline';
import ThemeSelector from './ThemeSelector';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../context/UserContext';

interface SidebarProps {
  className?: string;
  isMobileOpen?: boolean;
  onCloseMobile?: () => void;
}

const menuItems: AppSidebarMenuItem[] = [
  { path: '/admin/dashboard', labelKey: 'navigation.dashboard', icon: PresentationChartBarIcon },
  { path: '/admin/bookings', labelKey: 'navigation.bookings', icon: CalendarDaysIcon },
  { path: '/admin/calendar', labelKey: 'navigation.calendar', icon: CalendarDaysIcon },
  { path: '/admin/customers', labelKey: 'navigation.customers', icon: UserGroupIcon },
  { path: '/admin/services', labelKey: 'navigation.services', icon: WrenchScrewdriverIcon },
  { path: '/admin/staff', labelKey: 'navigation.staff', icon: UsersIcon },
  { path: '/admin/booking-link', labelKey: 'navigation.bookingLink', icon: LinkIcon },
  { path: '/admin/settings', labelKey: 'navigation.settings', icon: BuildingStorefrontIcon },
];

const Sidebar: React.FC<SidebarProps> = (props) => {
  const { user, logout, language, updateUserLanguage } = useContext(UserContext)!;
  const { t, i18n } = useTranslation();

  return (
    <AppSidebar
      appName={t('app.title')}
      logoPath="/admin/dashboard"
      menuItems={menuItems}
      user={user}
      currentLanguage={language || i18n.language}
      onLanguageChange={(lng) => {
        if (updateUserLanguage) updateUserLanguage(lng as 'zh' | 'en' | 'ja');
        else i18n.changeLanguage(lng);
      }}
      onLogout={logout}
      themeSelector={<ThemeSelector />}
      currentSystem="BOOKING"
      profilePath="/admin/profile"
      adminPath="/admin/admin"
      manualPath="/admin/manual"
      {...props}
    />
  );
};

export default Sidebar;
